module.exports = __webpack_public_path__ + "img/DW365-074.7410e281.jpg";